<div class="modal-header">
  <h3 class="modal-title">{{ modalTitle }}</h3>
  <div class="header-actions">
    <i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;" (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<table class="table table-bordered form-inline enityDetails custom-table" [hidden]="minimise">
  <tr>
    @for (item of entityList; track $index) {
<td>
      <span><strong>{{ item.key }}</strong></span>
    </td>
}
  </tr>
  <tr>
    @for (item of entityList; track $index) {
<td>
      <span>{{ item.value }}</span>
    </td>
}
  </tr>
</table>

<div class="modal-body" [hidden]="minimise">
  @if (showFormLoader) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}

  @if (!showFormLoader) {
<div>
    <!-- Form content -->
  </div>
}
</div>

<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" type="button" [disabled]="crudLoading" (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
  </button>
  <button class="reset-button" type="button" (click)="reset()">Reset</button>
  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>
